import CSSModules from 'react-css-modules';

export const VODCSSModules = styles => WrappedComponent => {
  if (!styles) {
    return _.identity;
  }

  return CSSModules(WrappedComponent, styles, {
    allowMultiple: true,
    handleNotFoundStyleName: 'ignore',
  });
};

/** @deprecated */
export function WixConnect(styles) {
  return function(WrappedComponent) {
    const DecoratedComponent = VODCSSModules(styles)(WrappedComponent);
    DecoratedComponent.WixWrappedComponent = WrappedComponent;
    return DecoratedComponent;
  };
}
